import _ from 'lodash';
const DOMAIN: string = _.toString(process.env.REACT_APP_DOMAIN);

const API: string = _.toString(process.env.REACT_APP_API);

const UPLOAD: string = _.toString(process.env.REACT_APP_UPLOAD);

const PREVIEWFRAME: string = _.toString(process.env.REACT_APP_PREVIEW_FRAME);

const COOKIENAME = _.toString(process.env.REACT_APP_COOKIENAME);

const TITLE = _.toString(process.env.REACT_APP_TITLE);

const BASEURL = 'admin';
const BASEREVIEW = 'reviews';
const BASEQUESTION = 'questions';

const LISTURL = {
  not_found: `/${BASEURL}/pages/not-found`,
  unauthenticated: `/${BASEURL}/pages/unauthenticated`,
  documentation: `/${BASEURL}/documentation`,
  general: `/${BASEURL}/general`,
  reviews_list: `/${BASEURL}/${BASEREVIEW}/list`,
  reviews_reply: `/${BASEURL}/${BASEREVIEW}/replies`,
  reviews_import: `/${BASEURL}/${BASEREVIEW}/import`,
  question_list: `/${BASEURL}/${BASEQUESTION}/list`,
  question_reply: `/${BASEURL}/${BASEQUESTION}/replies`,
  question_import: `/${BASEURL}/${BASEQUESTION}/import`,
  settings: `/${BASEURL}/settings`,
  customers: `/${BASEURL}/customers`,
};

export {
  DOMAIN,
  API,
  UPLOAD,
  PREVIEWFRAME,
  COOKIENAME,
  TITLE,
  BASEURL,
  LISTURL,
  BASEREVIEW,
  BASEQUESTION,
};
